<template>
  <div class="cashflow-type-economy card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :recommended-or-expected-amount="economyExpenses.recommendedOrExpectedAmount"
                      :recommended-or-expected-label="titles.expenseProgress.recommendedLabel"
                      :up-to-now-label="titles.expenseProgress.actualsLabel"
                      :up-to-now-amount="economyExpenses.upToNowAmount"
                      :show-warning-if-exceeding-budget="false"/>

    <predicted-category-sections :actuals-title="titles.categorySections.actualsTitle"
                                 :recommended-title="titles.categorySections.recommendedTitle"
                                 :categories="economyExpenses.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="true"
                                 :is-section-editable="true"
                                 :title="titles.categorySections.mainTitle"
                                 :expense-category="titles.expenseCategory"
                                 v-on:edit-amount-clicked="emitOpenEditAmountPopup($event)"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="slotProps">
        <div class="transaction-list">
          <transaction class="transaction-details"
                                     v-for="transaction in slotProps.transactions"
                                     :transaction="transaction"
                                     :can-edit-category="true"
                                     :category-name="categoryName"
                                     v-bind:key="transaction.transactionId">
          </transaction>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import Transaction from '../../../generic-components/cashflow-types/cashflow-types-base/Transaction.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';
import EditAmountPopup from '../cashflow-edit/EditAmountPopup.vue';
import ModalBus from '../../../../../../../../../event-bus/modal-bus';

export default {
  name: 'CashflowTypeEconomy',
  mixins: [CashflowAnalytics],
  components: {
    Transaction,
    ExpenseProgress,
    PredictedCategorySections,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    CASHFLOW_TYPE() {
      return cashflowViewConsts.cashflowTypes.economy;
    },
    economyExpenses() {
      return this.cashflowUITree[this.CASHFLOW_TYPE];
    },
    categoryName() {
      return cashflowViewConsts.CATEGORY_NAMES.RECURRING_ECONOMY;
    },
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'יצא עד עכשיו',
          recommendedLabel: 'סה"כ צפוי לצאת',
        },
        categorySections: {
          actualsTitle: 'יצא',
          recommendedTitle: 'צפוי לצאת',
          mainTitle: 'פירוט שבועי של הוצאות סופר',
        },
        cardTitle: 'הוצאות סופר',
        expenseTitle: 'סופר',
        expenseCategory: 'כלכלה',
      };
    },
  },
  methods: {
    emitOpenEditAmountPopup(event) {
      const category = _.find(this.economyExpenses.categories, category => category.categoryId === event.categoryId);
      ModalBus.$emit('open', {
        component: EditAmountPopup,
        props: {
          expenseCategory: this.titles.expenseTitle,
          category,
        },
      });
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .cashflow-type-economy {
    @include cashflow-card;

    .title {
      @include cashflow-card-title;
    }

    .cashflow-type-color {
      color: $riseup_light_blue;
    }

    .cashflow-type-background-color {
      background-color: $riseup_light_blue;
    }
  }

</style>
